import type { PropsWithChildren } from "react";

import { OWNER_RIGHT } from "@/lib/rights";

import { RequireRight } from "./RequireRight";

/**
 * Gate routes the owner alone should see (audit log, reports, …).
 * Mirrors the server-side `require_right("owner")`. Bounces non-
 * owners to `/admin` rather than `/` — an admin who lands here by
 * typo expects to land back in their familiar admin shell, not the
 * catalog. Wraps `RequireRight` so the gate forces a fresh /me on
 * mount.
 */
export function RequireOwner({ children }: PropsWithChildren) {
  return (
    <RequireRight right={OWNER_RIGHT} fallback="/admin">
      {children}
    </RequireRight>
  );
}
